// extracted by mini-css-extract-plugin
export default {"container":"KotlettBugreportFeature__container--2EjCb"};